export default __webpack_public_path__ + "static/media/intro-ai.52590732.jpg";